'use client';

import React, { useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { useTranslations } from 'next-intl';
import Button from '@/ui/components/shared/Button';
import { ClubJoinModal } from '@/ui/components/club-join-modal/club-join-modal';

export interface ClubOnlyPurchaseActionsProps {
  isLoggedIn: boolean;
  // Where the club signup from the join modal came from, e.g. the chooser.
  nag: string;
  onLogIn: () => void;
  className?: string;
}

/** Replaces "Add to cart" for Nuki Club only items when the visitor is not a club member. */
export function ClubOnlyPurchaseActions({
  isLoggedIn,
  nag,
  onLogIn,
  className,
}: Readonly<ClubOnlyPurchaseActionsProps>) {
  const t = useTranslations('ProductChooser');
  const [isJoinClubOpen, setIsJoinClubOpen] = useState(false);

  return (
    // Side by side from small screens up; on a phone both labels do not fit in one row.
    <div
      data-testid="club-only-purchase-actions"
      className={twMerge('flex flex-col gap-2 sm:flex-row', className)}
    >
      {!isLoggedIn && (
        <Button
          className="w-full whitespace-nowrap sm:flex-1"
          type="button"
          onClick={onLogIn}
          data-tile-element-id="club-purchase-log-in"
        >
          {t('logInToUnlock')}
        </Button>
      )}
      <Button
        className="w-full whitespace-nowrap sm:flex-1"
        type="button"
        onClick={() => setIsJoinClubOpen(true)}
        data-tile-element-id="club-purchase-join-club"
      >
        {t('joinNukiClubToBuy')}
      </Button>
      {/* Joining as a logged in visitor makes them a member, which unmounts these actions and
          closes the modal together with them. */}
      <ClubJoinModal
        isOpen={isJoinClubOpen}
        isLoggedIn={isLoggedIn}
        nag={nag}
        onClose={() => setIsJoinClubOpen(false)}
        onLogIn={onLogIn}
      />
    </div>
  );
}
